import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonCheckbox,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonLabel,
  IonPage,
  IonRow,
  IonSegment,
  IonSegmentButton,
  IonText,
  IonToast,
  IonToolbar,
  isPlatform,
} from "@ionic/react";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { findDocumentsTypes } from "../../store/MassNotification/actions/findDocumentTypes";
import { DocumentTypesSelector } from "./components/DocumentTypesSelector";
import { DocumentTypesSelected } from "./components/DocumentTypesSelected";
import { findTotalPeople } from "../../store/MassNotification/actions/findTotalPeople";
import { RootState } from "../../store/rootReducer";
import {
  setDeselectAllPeople,
  setEmail,
  setInitialData,
  setWhatsapp,
} from "../../store/MassNotification";
import { ConfirmButton } from "./components/ConfirmButton";
import { logoWhatsapp, mailOutline, peopleOutline } from "ionicons/icons";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { FilterCreatedAtSelector } from "./components/FilterCreatedAtSelector";
import { FilterDateChip } from "./components/FilterDateChip";
import { findUserRoles } from "../../store/massiveDocumentCreate/actions/findUserRoles";
import { findLocations } from "../../store/massiveDocumentCreate/actions/findLocations";

const checkboxTextStyle = {
  fontSize: 13,
  fontWeight: "bold",
  verticalAlign: "middle",
};

const checkboxIconStyle = {
  paddingLeft: 5,
  fontSize: 25,
  fontWeight: "bold",
  verticalAlign: "middle",
};

const checkboxStyle = {
  verticalAlign: "middle",
};

const divChannelsSelector = {
  paddingLeft: "25px",
  paddingRight: "10px",
};

export const MassNotification = () => {
  const [token, setToken] = useState("");
  const [selectorActive, setSelectorActive] = useState<boolean>(true);
  const dispatch = useDispatch();
  const state = useSelector((state: RootState) => state.massNotification);

  useEffect(() => {
    dispatch(setInitialData());
    dispatch(findUserRoles());
    dispatch(findLocations());
    dispatch(findDocumentsTypes());
    dispatch(findTotalPeople());
  }, []);

  const handleNotificationDismiss = () => {
    dispatch(setInitialData());
    dispatch(findDocumentsTypes());
    dispatch(findTotalPeople());
  };

  return (
    <IonPage>
      <IonHeader class="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton
              text={isPlatform("ios") ? "Acuerdos" : ""}
              defaultHref={"/app/rrhh/acuerdos"}
              color="light"
            />
          </IonButtons>
          <IonButtons slot="end">
            <IonRow style={{ display: "flex", justifyContent: "end", padding: "10px" }}>
              <div>
                <IonCheckbox
                  style={checkboxStyle}
                  checked={state.email}
                  onIonChange={(e) => dispatch(setEmail(e.detail.checked))}
                />{" "}
                <IonIcon icon={mailOutline} style={checkboxIconStyle} className="ion-hide-md-up" />
                <span style={checkboxTextStyle} className="ion-hide-md-down">
                  &nbsp;CORREO ELECTRÓNICO
                </span>
              </div>
              <div style={divChannelsSelector}>
                <IonCheckbox
                  style={checkboxStyle}
                  checked={state.whatsapp}
                  onIonChange={(e) => dispatch(setWhatsapp(e.detail.checked))}
                />{" "}
                <IonIcon icon={logoWhatsapp} style={checkboxIconStyle} className="ion-hide-md-up" />
                <span style={checkboxTextStyle} className="ion-hide-md-down">
                  &nbsp;WHATSAPP
                </span>
              </div>
            </IonRow>
            <GoogleReCaptchaProvider
              reCaptchaKey="6Lf8EDQmAAAAAOmB16rzgKEpjk9FLb-_31B0eF-3"
              language="es"
            >
              <ConfirmButton />
            </GoogleReCaptchaProvider>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <section className={"ion-margin"}>
          <IonText color="primary">
            <h2>Notificaciones Masivas</h2>
            <p>
              Cantidad de personas:{" "}
              {state.findTotalPeopleStatus === "succeeded" && state.totalPeople}
            </p>
          </IonText>
          <IonRow style={{ display: "flex", justifyContent: "end", padding: "10px" }}>
            <FilterDateChip />
            <IonButton
              color="secondary"
              routerLink={"/app/rrhh/acuerdos/notificacion-especifica"}
              disabled={state.selectedDocumentTypes.length === 0}
              onClick={() => {
                dispatch(setDeselectAllPeople());
              }}
            >
              <span className="ion-hide-md-down">Ajustar criterio por persona</span>
              <IonIcon icon={peopleOutline} className="ion-hide-md-up" />
            </IonButton>
          </IonRow>
          <IonGrid class="ion-no-margin ion-no-padding">
            {/* Inicio - Para móviles */}
            <IonRow className="ion-hide-md-up">
              <IonSegment
                value={selectorActive ? "disponibles" : "seleccionados"}
                color="secondary"
                style={{
                  maxWidth: "100%",
                  position: "fixed",
                  bottom: 0,
                  left: 0,
                  backgroundColor: "white",
                  zIndex: 1000,
                }}
              >
                <IonSegmentButton
                  value="disponibles"
                  onClick={() => {
                    setSelectorActive(true);
                  }}
                >
                  <IonLabel>Disponibles</IonLabel>
                </IonSegmentButton>
                <IonSegmentButton
                  value="seleccionados"
                  onClick={() => {
                    setSelectorActive(false);
                  }}
                >
                  <IonLabel>Seleccionados</IonLabel>
                </IonSegmentButton>
              </IonSegment>
              <IonCol style={{ paddingLeft: 0, paddingRight: 6 }}>
                {selectorActive ? <DocumentTypesSelector /> : <DocumentTypesSelected />}
              </IonCol>
              <IonFooter style={{ height: "2rem" }} className="ion-no-border"></IonFooter>
            </IonRow>
            {/* Fin - Para móviles */}
            {/* Inicio - para desktop */}
            <IonRow className="ion-hide-md-down">
              <IonGrid class="ion-no-margin ion-no-padding">
                <IonRow>
                  <IonCol size="6" style={{ paddingLeft: 0, paddingRight: 6 }}>
                    <DocumentTypesSelector />
                  </IonCol>
                  <IonCol size="6" style={{ paddingRight: 0, paddingLeft: 6 }}>
                    <DocumentTypesSelected />
                  </IonCol>
                </IonRow>
              </IonGrid>
            </IonRow>
            {/* Fin - Para desktop */}
          </IonGrid>
        </section>
      </IonContent>
      {state.sendNotificationStatus === "pending" && (
        <IonToast
          isOpen={true}
          onDidDismiss={() => {}}
          message="Enviando solicitud de notificación masiva"
          position="bottom"
          duration={3000}
          color="primary"
        />
      )}
      {state.sendNotificationStatus === "succeeded" && (
        <IonToast
          isOpen={true}
          onDidDismiss={handleNotificationDismiss}
          message="La solicitud de notificación fue enviada correctamente"
          position="bottom"
          duration={3000}
          color="success"
        />
      )}
      {state.sendNotificationStatus === "failed" && (
        <IonToast
          isOpen={true}
          onDidDismiss={() => {}}
          message="Ocurrió un error en la solicitud de notificación"
          position="bottom"
          duration={3000}
          color="danger"
        />
      )}
      <FilterCreatedAtSelector />
    </IonPage>
  );
};
